import api from './api';
import type { ApiResponse, LoyaltySettings, LoyaltyStats, PointsLedgerEntry, Client } from '../types';

const BASE = '/loyalty';

const loyaltyService = {
  getSettings:    ()                             => api.get<ApiResponse<LoyaltySettings>>(`${BASE}/settings`).then(r => r.data),
  updateSettings: (data: Partial<LoyaltySettings>) => {
    const payload = { ...data };
    delete payload._id;
    delete payload.branch;
    return api.put<ApiResponse<LoyaltySettings>>(`${BASE}/settings`, payload).then(r => r.data);
  },
  getStats:       ()                             => api.get<ApiResponse<LoyaltyStats>>(`${BASE}/stats`).then(r => r.data),
  getClients:     (params: Record<string,string> = {}) => api.get<ApiResponse<Client[]> & { total: number }>(`${BASE}/clients`, { params }).then(r => r.data),
  getHistory:     (clientId: string)             => api.get<ApiResponse<PointsLedgerEntry[]>>(`${BASE}/clients/${clientId}/history`).then(r => r.data),
  adjustPoints:   (clientId: string, data: { points: number; description: string }) =>
    api.post<ApiResponse<Client>>(`${BASE}/clients/${clientId}/adjust`, data).then(r => r.data),
  redeemMilestone: (clientId: string, milestoneIndex: number) =>
    api.post<ApiResponse<{ voucher: unknown; client: Client }>>(`${BASE}/clients/${clientId}/redeem-milestone`, { milestoneIndex }).then(r => r.data),
  redeemManualVoucher: (clientId: string, voucherId: string) =>
    api.post<ApiResponse<{ voucher: unknown; client: Client }>>(`${BASE}/clients/${clientId}/redeem-voucher`, { voucherId }).then(r => r.data),
};

export default loyaltyService;
